import { Pipe, PipeTransform } from '@angular/core';
import { SlugService } from '../../common/slug/slug.service';

@Pipe({
  name: 'slug',
  standalone: true,
})
export class SlugPipe implements PipeTransform {
  constructor(private slugService: SlugService) {}

  transform(value: any, instanceId?: string, userId?: string): string {
    if (!value) return '';
    return this.slugService.slug(value, instanceId, userId);
  }
}
